import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { findLecture } from './infra/repository/FindLecture';
import { writingPracticeSubmit } from './WritingPractice';
import { LetureNavigationMenu } from './LetureNavigationMenu';
import EditLink from '../../shared/components/EditLink';
import './style/lecture.scss';

export default function Lecture() {
  const { search } = useLocation();
  const pageId = new URLSearchParams(search).get('pageId');
  const [state, setState] = useState({});
  useEffect(() => {
    let active = true;
    setState({ loading: true });
    if (!pageId) { setState({ error: 'No page selected.' }); return; }
    findLecture(pageId).then(page => { if (active) setState({ page, pageId }); })
      .catch(() => { if (active) setState({ error: 'Unable to load this page. It may have been removed from the course.' }); });
    return () => { active = false; };
  }, [pageId]);
  const page = state.pageId === pageId ? state.page : null;
  useEffect(() => {
    if (page) return writingPracticeSubmit();
  }, [page]);
  return <div className="lecture__container">
    <div className="lecture__container--navigation-menu">
      <LetureNavigationMenu courseId={page?.courseId} />
    </div>
    <main className="lecture__container--view">
      {state.loading && <p><output>Loading page…</output></p>}
      {state.error && <p role="alert">{state.error}</p>}
      {page && <>
        <header className="lecture__header"><h1>{page.name}</h1>
          {page.courseId && <EditLink to={`/editor/page/${page.id}/edit`} label="Edit page" />}
        </header>
        {!page.html && <p>This page is ready to be written. Choose Edit to add its lesson.</p>}
        <div className="page-content" dangerouslySetInnerHTML={{ __html: page.html }} />
      </>}
    </main>
  </div>;
}
